module.exports = __webpack_public_path__ + "static/media/software-darkblue-diamond.1ab2ea1e.svg";